import Option from './parts/Option'
import { ColorEnum } from '@/constants/color'
import ConfirmButton from '@/features/common/buttons/ConfirmButton'
import ModalHeading from '@/features/common/components/ModalHeading'
import { State } from '@/features/orders/constants/app'
import { PrintJobType, ReceiptType } from '@/features/print/constants'
import Modal from '@/features/ui/components/Modal'
import { useAppSelector } from '@/hooks/redux'
import { ordersSelectors } from '@/redux/reducers/orders/selectors'
import { isDeliveryOrder } from '@/utils/isDeliveryOrder'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface ReprintModalProps {
    orderUuid: string
    onDismiss: () => void
}

const ReprintModal: FC<ReprintModalProps> = ({ orderUuid, onDismiss }) => {
    const order = useAppSelector(ordersSelectors.orderByUuid(orderUuid))

    const { t } = useTranslation()

    if (!order) return null

    return (
        <Modal>
            <View style={styles.container}>
                <ModalHeading>{t('order.detail.action.reprint')}</ModalHeading>
                <View style={styles.optionList}>
                    <Option entry={{ orderUuid, printType: PrintJobType.KitchenBon }} isFirst />
                    {isDeliveryOrder(order) && (
                        <Option entry={{ orderUuid, printType: PrintJobType.DeliveryTicket }} />
                    )}
                    {order.receiptUuid && (
                        <Option
                            entry={{
                                orderUuid,
                                printType: PrintJobType.Receipt,
                                receiptType: ReceiptType.Original,
                            }}
                        />
                    )}
                    {order.receiptUuid && order.state === State.Cancelled && (
                        <Option
                            entry={{
                                orderUuid,
                                printType: PrintJobType.Receipt,
                                receiptType: ReceiptType.Cancellation,
                            }}
                        />
                    )}
                </View>
                <View style={styles.buttonContainer}>
                    <ConfirmButton onConfirm={onDismiss} label={t('actions.cancel')} />
                </View>
            </View>
        </Modal>
    )
}

const styles = StyleSheet.create({
    container: {
        gap: 32,
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 32,
        paddingHorizontal: 16,
        borderRadius: 16,
        backgroundColor: ColorEnum.GRAY_100,
    },
    optionList: {
        alignSelf: 'stretch',
    },
    buttonContainer: {
        alignSelf: 'stretch',
    },
})

export default ReprintModal
